<template>
  <div :class="checkWidth() + ' ' + 'container'">
    <template v-if="loading">
      <div class="container vertical-center">
        <LoadingMDL />
      </div>
    </template>
    <template v-else>
      <CRow alignHorizontal="center" alignVertical="center">
        <CCol col="1">
          <CRow alignHorizontal="end">
            <div
              class="containerIconLeft"
              @click="funcRoute(content.navigate.previous.action)"
              v-if="!mode.pretestMode && !mode.posttestMode && !mode.testmode"
            >
              <font-awesome-icon
                class="IconLeft"
                icon="chevron-left"
              ></font-awesome-icon>
            </div>
          </CRow>
        </CCol>
        <CCol col="10">
          <CardSelection
            :cardContent="content"
            :Type="Type"
            :cardType="cardType"
            @setIsNextButtonActive="setIsNextButtonActive"
            @selectedAns="selectedAns"
            :soundOBJ="soundObject"
            :AnswerType="AnswerType"
            :initialAnswer="data"
            :AnswerChoice="answer"
          />
          <CModal
            :title="ModalData.title"
            centered
            :color="ModalData.color"
            :show.sync="ShowAnswerModal"
            :closeOnBackdrop="false"
            class="CmodalShowAnswer"
          >
            <template v-if="ModalData.color === 'danger'">
              <h2>{{ ModalData.data.split('#')[0] }}</h2>
              <h2 class="fontChinese">{{ ModalData.data.split('#')[1] }}</h2>
            </template>
            <template v-else
              ><h2>{{ ModalData.data.split('#')[0] }}</h2></template
            >
            <br />
            <CRow align-vertical="end" align-horizontal="center">
              <CButton
                @click="ModalRoute()"
                color="success"
                shape="pill"
                class="ml-2 mr-2 mt-5"
                >Next</CButton
              >
            </CRow>
          </CModal>
        </CCol>
        <CCol col="1">
          <CRow>
            <div class="containerIconRight" @click="beforeSet()">
              <font-awesome-icon
                class="IconRight"
                icon="chevron-right"
              ></font-awesome-icon>
            </div>
          </CRow>
        </CCol>
      </CRow>
    </template>
  </div>
</template>

<script>
import '../../assets/scss/_chineseStyle.scss';
import '../../assets/scss/_chineseIcon.scss';
import '../../assets/scss/_chineseModalCustom.scss';
import CardPopupImg from '../../components/template/Chinese1/CardPopupImg';
import PopupIntroCModal from '../../components/template/Chinese1/PopupIntroCModal';
import CardSelection from '../../components/template/Chinese1/CardSelection';
import {mapGetters} from 'vuex';
import LoadingMDL from '../../components/loading/LoadingMDL';
import preTestTemplate from '../../assets/json/pre_test_chn.json';
import testTemplate from '../../assets/json/test_IAM05';

export default {
  components: {CardSelection, CardPopupImg, PopupIntroCModal, LoadingMDL},
  name: 'IAM05',
  data() {
    return {
      isNextButtonActive: false,
      content: {},
      CheckWidth: window.innerWidth,
      lang: this.$store.getters['language/getLanguage'],
      baseUrl: process.env.VUE_APP_URL_SOUND,
      Type: '',
      AnswerType: '',
      cardType: 'assignment',
      code: '',
      selectAns: '',
      selectAnsMulti: [],
      soundObject: {},
      userTemplateData: [],
      nextAction: [],
      TrueAns: '',
      mode: {},
      ShowAnswerModal: false,
      ModalData: {
        title: '',
        color: '',
        data: '',
      },
      data: [],
      answer: [],
      template: '',
      exceptionPath: [
        'IAM05-46',
        'IAM05-47',
        'IAM05-48',
        'IAM05-89',
        'IAM05-90',
        'IAM05-131',
        'IAM05-132',
        'IAM05-133',
        'IAM05-134',
        'IAM05-135',
        'IAM05-178',
        'IAM05-179',
        'IAM05-245',
        'IAM05-335',
        'IAM05-336',
        'IAM05-337',
        'IAM05-338',
        'IAM05-339',
        'IAM05-340',
        'IAM05-341',
        'IAM05-342',
      ],

      check: 0,
      i: 0,
      courseSection: '',
      startTime: '',
      condition: {},
      loading: false,
      isDone: false,
      newPath: '',
      mainUrl: [],
      nextRoute: '',
    };
  },

  computed: {
    ...mapGetters({
      allCourse: 'template/getTemplateContent',
      getUserTemplate: 'template/getUserTemplate',
      loadingGetter: 'template/loadingGetter',
      getCheckAnswerResult: 'template/getCheckAnswerResult',
      getMode: 'necessary/getMode',
    }),
  },

  watch: {
    allCourse: function (val) {
      this.check = 0;
      this.nextRoute = val.navigate.next.action;
      if (!val.enable) {
        alert('Access denied!');
        this.$router.push({name: val.navigate.close.action});
      } else {
        this.check += 1;
        this.content = val;
        this.checkType(val);
        // this.courseSection = this.$store.getters[
        //   "necessary/getLerningCourse"
        // ].groups[0].code;
        this.courseSection =
          this.$store.getters['necessary/getUserCourseSection'];
        console.log('xxxxxxx', this.courseSection);
        this.soundObject = new Audio(
          this.baseUrl + val.content.question[0].item[0].item.data
        );

        this.template = val._id;
        this.$store.dispatch('template/createUserTemplateData', {
          code: this.courseCode,
          template: val._id,
          section: this.courseSection,
        });

        this.data = Array(val.content.question[0].item[0].item.comment.length);
        this.answer = val.content.question[0].choices;
        this.check = 0;
      }
    },
    getUserTemplate: function (val) {
      this.i += 1;
      if (val.data.condition.criteriaType.length > 0) {
        this.condition = {
          criteria: val.data.condition.criteriaType[0].criteria._id,
          val: val.data.condition.criteriaType[0].val,
        };
      } else {
        this.condition = {};
      }

      this.loading = false;
    },
    getCheckAnswerResult: function (val) {
      console.log(val, 'value chcek');

      let templateCode = `IAM05-` + this.$route.params.id;
      let except = this.exceptionPath.filter((i) => {
        if (templateCode == i) {
          return i;
        }
      });
      if (val) {
        if (except.length == 0) {
          let isPreTest = preTestTemplate.filter((i) => {
            if (templateCode == i) {
              return i;
            }
          });
          let isTest = testTemplate.filter((i) => {
            if (templateCode == i) {
              return i;
            }
          });

          if (isPreTest.length > 0 || isTest.length > 0) {
            this.ModalRoute();
          } else {
            if (val.userAnswer[0].status) {
              this.ModalData = {
                title: 'Result',
                color: 'success',
                data: 'Correct #' + val.correctAnswer[0].correct,
              };
              this.ShowAnswerModal = true;
            } else {
              if (isPreTest.length == 0) {
                this.ModalData = {
                  title: 'Result',
                  color: 'danger',
                  data:
                    'Incorrect. the correct answer is #' +
                    val.correctAnswer[0].correct,
                };
              } else {
                this.ModalData = {
                  title: 'Result',
                  color: 'danger',
                  data: 'Incorrect',
                };
              }

              this.loading = false;
              this.ShowAnswerModal = true;
            }
          }
        } else {
          let now = `IAM05-` + this.$route.params.id;
          let next = this.nextAction;
          let split_next = next.split('/');
          if (split_next[1] == 'IAM05') {
            let answer = val.userAnswer[0].status;
            if (answer) {
              this.$store.commit('necessary/setScore', 1);
            } else {
              this.$store.commit('necessary/setScore', 0);
            }

            let body = {};
            body.code = this.courseCode;
            body.templateCode = `IAM05-` + this.$route.params.id;
            this.$store.dispatch('template/fetchContent', body);
            this.$router.push(this.nextAction);
            if (
              now !== 'IAM05-134' ||
              now !== 'IAM05-338' ||
              now !== 'IAM05-342'
            ) {
              location.reload();
            }
          } else if (
            this.nextAction == '/LKT01/65' ||
            this.nextAction == '/LKT01/66'
          ) {
            let answer = val.userAnswer[0].status;
            if (answer) {
              this.$store.commit('necessary/setScore', 1);
            } else {
              this.$store.commit('necessary/setScore', 0);
            }
            this.$router.push(this.nextAction);
          } else {
            this.$router.push(this.nextAction);
          }
        }
      }
    },
    data: function (val) {
      console.log(val);
      console.log(typeof val);

      var checkMulti = this.content.content.question[0].multiSelect;
      if (checkMulti == true) {
        for (let i = 0; i < val.length; i++) {
          if (i === 0) {
            this.selectAns = val[i];
          } else if (i > 0) {
            if (val[i] != undefined) {
              this.selectAns = this.selectAns + val[i];
            }
          }
        }
      } else {
        this.selectAns = val;
      }
    },
  },

  mounted() {
    let body = {};
    body.code = this.courseCode;
    body.templateCode = `IAM05-` + this.$route.params.id;
    this.$store.dispatch('template/fetchContent', body);

    //let body = `IAM05-` + this.$route.params.id;
    if (
      body.templateCode === 'IAM05-131' ||
      body.templateCode === 'IAM05-335' ||
      body.templateCode === 'IAM05-339'
    ) {
      this.$store.commit('score/setDefaultPoint');
      this.$store.commit('necessary/setScoreToZero');
      this.$store.commit('necessary/setClearScore', 0);
    }
  },

  created() {
    this.isShow = false;
    this.check = 0;
    this.courseCode = this.$store.getters['necessary/getLerningCourse']._id;
    this.lang = this.$store.state.language.language;
    this.startTime = this.$helpers.getDateFormat();
  },

  beforeDestroy() {},
  methods: {
    checkWidth() {
      if (this.CheckWidth > 800) {
        return 'container-chinese-card';
      } else if (this.CheckWidth <= 800) {
        return 'container-chinese-card-mobile';
      }
    },
    selectedAns(data) {
      var checkMulti = this.content.content.question[0].multiSelect;
      if (checkMulti == true) {
        let final = '';
        if (data.length > 0) {
          data.forEach((item, index) => {
            final += item;
          });
        }
        this.selectAns = final;
      } else {
        this.selectAns = data;
      }
    },
    checkLangClass() {
      if (this.lang == 'CN') {
        return 'fontChinese';
      } else if (this.lang == 'PIN IN') {
        return 'fontPinin';
      } else {
        return '';
      }
    },
    checkType(val) {
      var answerType = val.content.question[0].item[0].type;
      if (answerType == 3) {
        this.AnswerType = 'text';
      } else if (answerType == 2) {
        this.AnswerType = 'audio';
      } else if (answerType == 1) {
        this.AnswerType = 'image';
      }

      var type = val.content.question[0].item[0].item.type;
      if (type == 3) {
        this.Type = 'text';
      } else if (type == 2) {
        this.Type = 'audio';
      } else if (type == 1) {
        this.Type = 'image';
      }
    },
    popupData2(x, code) {
      this.popUpIntroData = x;
      this.code = code;
      this.isShow = false;
      this.isShowPopupIntro = true;
    },
    setIsNextButtonActive(status) {
      this.isNextButtonActive = status;
    },
    getNextButtonColor(status) {
      if (status) return 'containerIconRight-matrix active';
      else return 'containerIconRight-matrix';
    },
    beforeSet() {
      if (this.selectAns !== '') {
        this.loading = true;
        this.setData();
      } else {
        alert('Please complete exercise');
      }
    },
    setData() {
      let audio = this.soundObject;
      if (this.soundObject) {
        audio.pause();
      }
      var path = this.content.navigate.next.action;
      let str = path.split('-');
      this.mainUrl = str;
      this.nextAction = '/' + str[0] + '/' + str[1];
      this.TrueAns =
        this.content.content.question[0].choices[0].choice.choices.item.comment;

      let test = [];
      if (this.condition !== {}) {
        test.push(this.condition);
      }

      let userCriteria = {
        code: this.courseCode,
        template: this.template,
        section: this.courseSection,
        answering: [
          {
            answer: this.selectAns,
          },
        ],
        startTime: this.startTime,
        endTime: this.$helpers.getDateFormat(),
        condition: test,
      };
      this.loading = false;
      this.$store.dispatch('template/saveUserTemplateData', userCriteria);
    },
    funcRoute(tempId) {
      if (tempId === 'PreTest') {
        alert('You cannot exit while doing pretests.');
      } else {
        let previousPage = this.content.navigate.previous.action.split('-');
        let checkUrl = previousPage[0];
        if (checkUrl === 'IAM05') {
          let body = {};
          body.code = this.courseCode;
          body.templateCode = `IAM05-` + previousPage[1];
          this.$store.dispatch('template/fetchContent', body);
        }
        this.$router.push('/' + previousPage[0] + '/' + previousPage[1]);
      }
    },
    ModalRoute() {
      let nextPage = this.nextRoute.split('-');
      if (nextPage[0] === 'IAM05') {
        let body = {};
        body.code = this.courseCode;
        body.templateCode = `IAM05-` + nextPage[1];
        this.$store.dispatch('template/fetchContent', body);
        this.loading = true;
      }
      this.$router.push('/' + nextPage[0] + '/' + nextPage[1]);
      this.ShowAnswerModal = false;
    },
  },
};
</script>
<style></style>
